import i18n from '@/plugins/i18n';
import BuildConfig from '@/environment';

export const MAX_USER_COUNT =
  BuildConfig.VUE_APP_USER_ACCOUNTS_LIMIT ||
  process.env.VUE_APP_USER_ACCOUNTS_LIMIT ||
  10;

export const HEADERS = () => [
  {
    dataIndex: 'fullName',
    key: 'fullName',
    title: i18n.global.t('setting.fullName'),
    width: '15%',
    ellipsis: true,
  },
  {
    key: 'emailId',
    dataIndex: 'emailId',
    title: i18n.global.t('setting.email'),
    width: '20%',
    routable: false,
    ellipsis: true,
  },
  {
    key: 'createdAt',
    dataIndex: 'createdAt',
    title: i18n.global.t('setting.createdOn'),
    width: '19%',
    defaultOrder: 'DES',
    ellipsis: true,
  },
  {
    key: 'roleCount',
    dataIndex: 'roleCount',
    title: i18n.global.t('setting.role'),
    width: '18%',
    ellipsis: true,
  },
  {
    title: i18n.global.t('setting.groupRole'),
    dataIndex: 'groupRoleCount',
    key: 'groupRoleCount',
    width: '18%',
    ellipsis: true,
  },
  {
    type: 'actions',
    title: i18n.global.t('setting.actions'),
    key: 'actions',
    dataIndex: 'actions',
    width: '10%',
  },
];

export const ACTION_TYPE = {
  copy: 'copy',
  edit: 'edit',
  delete: 'delete',
};

export const ACTIONS = [
  {
    type: ACTION_TYPE.copy,
    key: ['copyPassword'],
    icon: 'copyStripes',
    toolTip: {
      content: i18n.global.t('setting.copyResetLink'),
    },
  },
  {
    type: ACTION_TYPE.edit,
    key: ['editAlert'],
    icon: 'editFilled',
    toolTip: {
      content: i18n.global.t('setting.edit'),
    },
  },
  {
    type: ACTION_TYPE.delete,
    key: ['deleteAlert'],
    icon: 'deleteFilled',
    toolTip: {
      content: i18n.global.t('setting.delete'),
    },
  },
];

export const BILLING_ADMIN = 'BI_ADMIN';

export const PLATFORM_TEAM_ADMIN = 'TEAM_ADMIN';

export const READ_ONLY_USER = 'USER';

export const USER_TYPE_STANDARD = 'STANDARD';
export const DISABLE_SECTION = ['account'];
export const disableTabsForOcUser = ['userAdmin'];
